/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Table, Button, Card, Row, Col, Typography, message, Spin, Breadcrumb } from "antd";
import { ArrowLeftOutlined, DownloadOutlined, HomeOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { HubCPOverviewService } from "../../../../services/api/hubCPOverviewService";

const { Title } = Typography;

const TotalAvailableShipmentsClickableReport = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { hubId } = location.state || {}; // Extract hubId from navigation state

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

    const columns = [
        {
            title: "Booking Date",
            dataIndex: "bookingDate",
            key: "bookingDate",
            width: 150,
        },
        {
            title: "Tracking ID",
            dataIndex: "trackingId",
            key: "trackingId",
            width: 150,
            render: (text) => (
                <span
                    style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        if (text) {
                            const url = `/shipment-tracker?awb=${text}`;
                            window.open(url, "_blank");
                        }
                    }}
                >
                    {text || "-"}
                </span>
            ),
        },
        {
            title: "Movement Type",
            dataIndex: "movementType",
            key: "movementType",
            width: 150,
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: 150,
        },
        {
            title: "Document Type",
            dataIndex: "documentType",
            key: "documentType",
            width: 120,
        },
        {
            title: "Service Type",
            dataIndex: "serviceType",
            key: "serviceType",
            width: 120,
        },
        {
            title: "Origin Hub",
            dataIndex: "originHub",
            key: "originHub",
            width: 180,
        },
        {
            title: "Current Location",
            dataIndex: "currentLocation",
            key: "currentLocation",
            width: 180,
        },
        {
            title: "Destination Hub",
            dataIndex: "destinationHub",
            key: "destinationHub",
            width: 180,
        },
        {
            title: "Latest Status Time",
            dataIndex: "latestStatusTime",
            key: "latestStatusTime",
            width: 180,
        },
        {
            title: "Ageing from status date",
            dataIndex: "ageingFromStatusDateInDays",
            key: "ageingFromStatusDateInDays",
            width: 150,
        },
    ];

    const fetchData = async (pageNum = 1, pageSize = 10) => {
        try {
            setLoading(true);
            const response = await HubCPOverviewService.getTotalAvailableShipmentsClickable({
                currentHubId: hubId,
                page: pageNum - 1, // API uses 0-based pagination
                size: pageSize
            });

            if (response) {
                setData(response.data);
                setPagination(prev => ({
                    ...prev,
                    current: pageNum,
                    pageSize: pageSize,
                    total: response.totalCount || 0
                }));
            }
        } catch (error) {
            message.error("Failed to fetch data");
            console.error("Error fetching Total Available Shipments:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(pagination.current, pagination.pageSize);
    }, [hubId]); // Refetch if hubId changes (though usually it won't in this view)

    const handleTableChange = (newPagination) => {
        fetchData(newPagination.current, newPagination.pageSize);
    };

    const handleDownload = async () => {
        try {
            setDownloadLoading(true);
            const downloadUrl = await HubCPOverviewService.getTotalAvailableShipmentsClickableDownload({
                currentHubId: hubId
            });

            if (downloadUrl) {
                window.open(downloadUrl, "_blank");
            } else {
                message.error("Failed to generate download link");
            }
        } catch (error) {
            message.error("Error downloading report");
            console.error("Download error:", error);
        } finally {
            setDownloadLoading(false);
        }
    };

    return (
        <div className="hub-manager-shipment-details" style={{ padding: "20px" }}>
            <Breadcrumb separator=">">
                <Breadcrumb.Item onClick={() => navigate("/dashboard")} style={{ cursor: "pointer" }}>
                    <HomeOutlined /> Dashboard
                </Breadcrumb.Item>
                <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                    Hub Manager Overview
                </Breadcrumb.Item>
                <Breadcrumb.Item>Total Available Shipments</Breadcrumb.Item>
            </Breadcrumb>

            <Card style={{ marginTop: "16px" }}>
                <Row justify="space-between" align="middle" style={{ marginBottom: "16px" }}>
                    <Col>
                        <Title level={4} style={{ margin: 0 }}>
                            <Button
                                icon={<ArrowLeftOutlined />}
                                onClick={() => navigate(-1)}
                                style={{ marginRight: "16px", border: "none", background: "transparent" }}
                            />
                            Total Available Shipments At Hub
                        </Title>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            onClick={handleDownload}
                            loading={downloadLoading}
                        >
                            Download Report
                        </Button>
                    </Col>
                </Row>

                <Table
                    columns={columns}
                    dataSource={data}
                    loading={loading}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                    onChange={handleTableChange}
                    rowKey="trackingId"
                    scroll={{ x: 1500 }}
                />
            </Card>
        </div>
    );
};

export default TotalAvailableShipmentsClickableReport;
